module.exports = __webpack_public_path__ + "static/media/search-button-cancel.dc97225e.svg";